<template>
  <section>
    <h2 class="text-xl md:text-2xl font-bold mb-4 md:mb-6">小说核心梗提取</h2>

    <div class="flex mb-6 border-b border-gray-200">
      <button class="px-4 md:px-6 py-2 rounded-t-md" :class="{ 'tab-active': inputMode === 'text' }" @click="inputMode = 'text'">输入文本</button>
      <button class="px-4 md:px-6 py-2 rounded-t-md" :class="{ 'tab-active': inputMode === 'file' }" @click="inputMode = 'file'">上传文件</button>
    </div>

    <div v-show="inputMode === 'text'" class="mb-6">
      <textarea v-model="content" class="w-full bg-white rounded-md p-3 resize-y min-h-[200px] focus:outline-none focus:ring-1 focus:ring-primary border border-gray-200" placeholder="请输入小说文本（最多30000字符）..."></textarea>
      <p class="text-textSub text-sm mt-2">当前字符数：{{ content.length }}/30000</p>
    </div>
    <div v-show="inputMode === 'file'" class="mb-6">
      <div class="w-full bg-white rounded-md p-8 flex flex-col items-center justify-center min-h-[200px] border-2 border-dashed border-gray-200 hover:border-primary transition-colors">
        <i class="fa-solid fa-upload text-4xl text-textSub mb-4"></i>
        <p class="text-textSub mb-4">点击或拖拽文件至此处上传</p>
        <p class="text-xs text-textSub">支持格式：TXT（最大30000字符）</p>
        <input ref="fileInput" type="file" class="hidden" accept=".txt" @change="onFileChange">
        <button class="mt-4 bg-primary text-white px-4 py-2 rounded-md btn-hover" @click="$refs.fileInput.click()">选择文件</button>
      </div>
      <div v-if="selectedFile" class="mt-3 bg-gray-50 border border-gray-200 rounded-md px-3 py-2 flex items-center justify-between text-xs md:text-sm text-textSub">
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-file-lines text-textSub"></i>
          <span class="break-all">{{ selectedFile.name }}</span>
        </div>
        <button
          type="button"
          class="text-primary hover:underline ml-3 whitespace-nowrap"
          @click="clearSelectedFile"
        >
          删除并重新选择
        </button>
      </div>
    </div>

    <button
      type="button"
      class="w-full bg-primary text-white py-3 rounded-md text-lg btn-hover mb-6 inline-flex items-center justify-center gap-2 flex-wrap"
      @click="startCreate"
    >
      <span>开始创作</span>
      <i class="fa-solid fa-bolt shrink-0 opacity-95" aria-hidden="true"></i>
      <span v-if="coinCost != null" class="text-sm font-normal opacity-90">{{ coinCost }}</span>
    </button>

    <div v-show="resultVisible" class="bg-white rounded-md p-6 border border-gray-200">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-semibold">核心梗提取结果</h3>
        <button class="copy-btn" @click="$emit('copy', resultText)">
          <i class="fa-solid fa-copy mr-1"></i>一键复制
        </button>
      </div>
      <div v-if="workName" class="text-sm text-textSub mb-3">
        作品名称：{{ workName }}
      </div>
      <div class="text-textSub mb-4 whitespace-pre-line">{{ resultText }}</div>
      <div class="flex justify-end">
        <button class="copy-btn" @click="$emit('copy', resultText)">
          <i class="fa-solid fa-copy mr-1"></i>一键复制
        </button>
      </div>
    </div>

    <!-- 开始创作：填写作品名称 -->
    <div
      v-if="workNameModalVisible"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      @click.self="closeWorkNameModal"
    >
      <div class="bg-white rounded-lg p-6 w-full max-w-md border border-gray-200 shadow-lg mx-4">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-semibold">开始创作</h3>
          <button class="text-textSub text-xl cursor-pointer" @click="closeWorkNameModal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="mb-5">
          <label class="block text-sm text-textSub mb-1">作品名称</label>
          <input
            v-model="workNameInput"
            type="text"
            class="w-full border border-gray-200 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary"
            placeholder="请输入作品名称"
          >
        </div>
        <div class="flex gap-3">
          <button
            class="flex-1 border border-gray-300 text-textMain py-2 rounded-md btn-hover"
            type="button"
            @click="closeWorkNameModal"
          >
            取消
          </button>
          <button
            class="flex-1 bg-primary text-white py-2 rounded-md btn-hover inline-flex items-center justify-center gap-2 flex-wrap"
            type="button"
            :disabled="creating"
            @click="confirmWorkNameAndCreate"
          >
            <template v-if="creating">处理中...</template>
            <template v-else>
              <span>确认并开始创作</span>
              <i class="fa-solid fa-bolt shrink-0 opacity-95" aria-hidden="true"></i>
              <span v-if="coinCost != null" class="text-sm font-normal opacity-90">{{ coinCost }}</span>
            </template>
          </button>
        </div>
      </div>
    </div>

    <!-- 提取中进度浮层 -->
    <div
      v-if="creating"
      class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
    >
      <div class="bg-white rounded-lg px-6 py-5 shadow-md border border-gray-200 max-w-sm w-full mx-4">
        <div class="flex items-center justify-center gap-2 mb-4">
          <i class="fa-solid fa-spinner fa-spin text-primary"></i>
          <div class="text-primary text-lg font-semibold">核心梗提取中...</div>
        </div>
        <div class="space-y-2 text-sm">
          <div class="flex items-start gap-2 text-textMain">
            <div class="mt-0.5">
              <i
                v-if="getStepStatus(0) === 'FAILED'"
                class="fa-solid fa-circle-xmark text-red-500"
              ></i>
              <i
                v-else-if="getStepStatus(0) === 'SUCCESS'"
                class="fa-solid fa-circle-check text-green-500"
              ></i>
              <i
                v-else
                class="fa-solid fa-circle text-gray-300"
              ></i>
            </div>
            <div class="flex-1">
              <div class="grid grid-cols-[1fr_12rem] items-center gap-3 leading-6">
                <span class="font-medium">核心梗提取中</span>
                <span class="text-textSub whitespace-nowrap text-right">预计1分钟，请耐心等待</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 text-xs text-textSub leading-relaxed">
          当前页面可放心刷新，任务不会中断，刷新后请到个人中心--我的资产--短篇小说中查看您的小说
        </div>
      </div>
    </div>

    <div class="guide-module">
      <h3 class="guide-title">
        <i class="fa-solid fa-lightbulb guide-icon"></i>
        核心梗提取使用攻略
      </h3>
      <div class="guide-list">
        <div class="guide-item"><i class="fa-solid fa-check-circle guide-icon"></i><span>输入文本建议包含完整故事线，至少500字以上</span></div>
        <div class="guide-item"><i class="fa-solid fa-check-circle guide-icon"></i><span>重点突出故事冲突，帮助AI精准识别核心梗</span></div>
        <div class="guide-item"><i class="fa-solid fa-check-circle guide-icon"></i><span>提取结果可作为小说宣传文案的核心素材</span></div>
        <div class="guide-item"><i class="fa-solid fa-check-circle guide-icon"></i><span>核心梗可直接用于小说大纲和封面创作参考</span></div>
      </div>
    </div>
  </section>
</template>

<script>
import { createCoreIdeaByText, uploadCoreIdeaFile, queryWorkTask } from '../api/coreIdea'
import coinCostActive from '../mixins/coinCostActive'
import { poll } from '../utils/poll'
import { readTextFileWithLimit } from '../utils/uploadValidator'

export default {
  name: 'CoreIdea',
  coinCostKey: 'coreIdea',
  mixins: [coinCostActive],
  data () {
    return {
      inputMode: 'text',
      content: '',
      resultVisible: false,
      resultText: '',
      selectedFile: null,
      creating: false,
      creatingLastResult: null,
      taskId: '',
      workName: '',
      workNameModalVisible: false,
      workNameInput: ''
    }
  },
  methods: {
    getStepStatus (idx) {
      const res = this.creatingLastResult
      if (!res) return ''
      const n = idx + 1
      const statusKey = 'step_' + n + '_status'
      const direct = res && res[statusKey]
      if (direct === 'SUCCESS' || direct === 'FAILED') return direct
      const progress = res && res.taskProgress
      if (typeof progress === 'string' && progress.indexOf('=') > -1) {
        const parts = progress.split('=').map(s => s.trim())
        if (parts[0] === String(n) && (parts[1] === 'SUCCESS' || parts[1] === 'FAILED')) return parts[1]
      }
      return ''
    },
    closeWorkNameModal () {
      this.workNameModalVisible = false
      this.workNameInput = ''
    },
    startCreate () {
      if (this.creating) return
      this.workNameModalVisible = true
    },
    async confirmWorkNameAndCreate () {
      if (this.creating) return
      const workName = (this.workNameInput || '').trim()
      if (!workName) {
        this.$emit('show-modal', '提示', '请输入作品名称。')
        return
      }
      this.workName = workName
      this.workNameModalVisible = false
      this.workNameInput = ''
      await this.doCreate()
    },
    pollTaskResult (taskId) {
      return poll(() => queryWorkTask(taskId), {
        onResult: (res) => {
          this.creatingLastResult = res || null
        },
        shouldStop: function (res) {
          return res && res.taskStatus === 'SUCCESS'
        },
        isError: function (res) {
          if (res && res.taskStatus === 'FAILED') {
            const msg = (res && (res.message || res.msg)) || '任务执行失败,不扣除点数'
            return new Error(msg)
          }
          return null
        },
        interval: 15000,
        maxTimes: 150
      })
    },
    async doCreate () {
      if (this.creating) return
      this.resultVisible = false
      this.resultText = ''
      this.taskId = ''
      this.creatingLastResult = null

      if (this.inputMode === 'text') {
        const content = (this.content || '')
        if (!content.trim()) {
          this.$emit('show-modal', '提示', '请输入要提取的文本内容。')
          return
        }
        this.creating = true
        try {
          const res = await createCoreIdeaByText({
            content,
            workName: this.workName || ''
          })
          const taskId = (res && (res.taskId != null ? res.taskId : (res.data && res.data.taskId))) || ''
          if (!taskId) {
            this.$emit('show-modal', '提取失败', '未返回任务ID，请稍后重试。')
            return
          }
          this.taskId = String(taskId)
          const data = await this.pollTaskResult(taskId)
          if (data) {
            const txt = (data && (data.text != null ? data.text : (data.content != null ? data.content : ''))) || ''
            this.resultText = typeof txt === 'string' ? txt : String(txt)
            this.resultVisible = true
          }
        } catch (err) {
          const msg = (err && err.message) || '提取失败，请稍后重试。'
          this.$emit('show-modal', '提取失败', msg)
        } finally {
          this.creating = false
        }
      } else if (this.inputMode === 'file') {
        if (!this.selectedFile) {
          this.$emit('show-modal', '提示', '请先选择要上传的文件。')
          return
        }
        const formData = new FormData()
        formData.append('workName', this.workName || '')
        formData.append('inputMode', 'file')
        formData.append('file', this.selectedFile)
        this.creating = true
        try {
          const res = await uploadCoreIdeaFile(formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          const taskId = (res && (res.taskId != null ? res.taskId : (res.data && res.data.taskId))) || ''
          if (!taskId) {
            this.$emit('show-modal', '提取失败', '未返回任务ID，请稍后重试。')
            return
          }
          this.taskId = String(taskId)
          const data = await this.pollTaskResult(taskId)
          if (data) {
            const txt = (data && (data.text != null ? data.text : (data.content != null ? data.content : ''))) || ''
            this.resultText = typeof txt === 'string' ? txt : String(txt)
            this.resultVisible = true
          }
        } catch (err) {
          const msg = (err && err.message) || '文件上传或处理失败，请稍后重试。'
          this.$emit('show-modal', '提取失败', msg)
        } finally {
          this.creating = false
        }
      }
    },
    async onFileChange (e) {
      const files = e && e.target && e.target.files
      if (!files || !files[0]) return
      const file = files[0]
      try {
        const info = await readTextFileWithLimit(file, { maxLength: 30000 })
        this.selectedFile = file
        this.$emit('show-modal', '文件选择成功', '已选择文件：' + file.name + '\n当前字数：' + info.length + '（上限 30000 字）')
      } catch (err) {
        this.selectedFile = null
        if (this.$refs.fileInput && this.$refs.fileInput.value) {
          this.$refs.fileInput.value = ''
        }
        const msg = err && err.message ? err.message : '文件读取失败，请稍后重试或更换文件。'
        this.$emit('show-modal', err && err.code === 'FILE_TOO_LARGE' ? '文件过大' : '文件读取失败', msg)
      }
    },
    clearSelectedFile () {
      this.selectedFile = null
      if (this.$refs.fileInput && this.$refs.fileInput.value) {
        this.$refs.fileInput.value = ''
      }
    }
  }
}
</script>
